import { useQuery } from "@tanstack/react-query";
import { useTacticHooks } from "../../providers/TacticHooksProvider";

export const BULK_IMPORT_QUERY_KEY = "useBulkImportQuery";

const ACTIVE_POLL_INTERVAL_MS = 2000;

export const useBulkImportQuery = (id: string | null | undefined) => {
  const { apiClient } = useTacticHooks();

  return useQuery({
    queryKey: [BULK_IMPORT_QUERY_KEY, apiClient.slug, id],
    queryFn: async () => {
      if (!id) {
        return null;
      }
      const res = await apiClient.bulkImports.get(id);
      return res.result;
    },
    enabled: !!apiClient.slug && !!id,
    refetchInterval: (query) => {
      const status = query.state.data?.status;
      if (status === "queued" || status === "processing") {
        return ACTIVE_POLL_INTERVAL_MS;
      }
      return false;
    }
  });
};
